const DEFAULT_TITLE = 'Ligne et Lore';

const stripHtml = value =>
  String(value || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const upsertMeta = (selector, attributes) => {
  if (typeof document === 'undefined') {
    return;
  }
  const shouldRemove = Object.values(attributes).some(
    value => value === null || value === undefined || value === '',
  );
  let meta = document.head.querySelector(selector);
  if (shouldRemove) {
    if (meta) {
      meta.remove();
    }
    return;
  }
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    meta.setAttribute(key, value);
  });
};

const upsertLink = (selector, attributes) => {
  if (typeof document === 'undefined') {
    return;
  }
  let link = document.head.querySelector(selector);
  if (!link) {
    link = document.createElement('link');
    document.head.appendChild(link);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      link.removeAttribute(key);
      return;
    }
    link.setAttribute(key, value);
  });
};

export const updateDocumentMetadata = ({
  title,
  description,
  image,
  url,
  type = 'website',
} = {}) => {
  if (typeof document === 'undefined') {
    return;
  }
  const safeTitle = stripHtml(title) || DEFAULT_TITLE;
  const safeDescription = stripHtml(description);
  const safeUrl =
    url ||
    (typeof window !== 'undefined' && window.location?.href
      ? window.location.href
      : '');

  document.title = safeTitle;
  upsertMeta('meta[name="description"]', {
    name: 'description',
    content: safeDescription,
  });
  upsertMeta('meta[property="og:title"]', {
    property: 'og:title',
    content: safeTitle,
  });
  upsertMeta('meta[property="og:description"]', {
    property: 'og:description',
    content: safeDescription,
  });
  upsertMeta('meta[property="og:type"]', {
    property: 'og:type',
    content: type,
  });
  upsertMeta('meta[property="og:url"]', {
    property: 'og:url',
    content: safeUrl,
  });
  upsertMeta('meta[name="twitter:card"]', {
    name: 'twitter:card',
    content: image ? 'summary_large_image' : 'summary',
  });
  upsertMeta('meta[name="twitter:title"]', {
    name: 'twitter:title',
    content: safeTitle,
  });
  upsertMeta('meta[name="twitter:description"]', {
    name: 'twitter:description',
    content: safeDescription,
  });
  upsertLink('link[rel="canonical"]', {
    rel: 'canonical',
    href: safeUrl,
  });

  if (image) {
    upsertMeta('meta[property="og:image"]', {
      property: 'og:image',
      content: image,
    });
    upsertMeta('meta[name="twitter:image"]', {
      name: 'twitter:image',
      content: image,
    });
  }
};

export const resetDocumentMetadata = () => {
  updateDocumentMetadata({ title: DEFAULT_TITLE, description: '' });
};
